/* eslint-disable no-unused-vars */
import React from 'react';
import { Link } from 'react-router-dom';
import { 
  BsFacebook, BsInstagram, BsTwitter, BsLinkedin, 
  BsYoutube, BsSkype, BsPinterest, BsTelegram,
  BsEnvelopeFill, BsTelephoneFill, BsGeoAltFill
} from 'react-icons/bs';

function Footersection() {
  return (
    <footer className="relative bg-[#0a0a0a] text-white">
      {/* Decorative Wave Top Divider */}
     

      <div className="mx-auto w-full max-w-screen-xl px-6 pt-20 pb-10">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
          
          {/* Brand Section */}
          <div className="space-y-6">
            <img 
              src="https://ik.imagekit.io/hickter/Hickter_Projects/MSWS/Logo/MSWS%20(6).png" 
              alt="Logo" 
              className="h-16 w-auto brightness-110" 
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Mahakal Social Welfare Society is dedicated to uplifting communities through sustainable development and compassionate action. Join us in making a difference.
            </p>
          <div className="flex flex-col gap-3 text-sm">
  <div className="flex items-center gap-3 text-orange-400">
    <BsTelephoneFill /> 
    <div className="text-gray-300 flex items-center gap-1.5 flex-wrap">
      <a href="tel:+918827529117" className="hover:text-orange-400 transition-colors duration-200">+91 8827529117</a>
      <span>/</span>
      <a href="tel:+917723024874" className="hover:text-orange-400 transition-colors duration-200">772-302-4874</a>
    </div>
  </div>
  
  <div className="flex items-center gap-3 text-orange-400">
    <BsEnvelopeFill /> 
    <a href="mailto:lakhansinghdikshit@gmail.com" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 break-all">
      lakhansinghdikshit@gmail.com
    </a>
  </div>
  
  <div className="flex items-start gap-3 text-orange-400">
    <BsGeoAltFill className="mt-1 flex-shrink-0" /> 
    <a 
      href="#" 
      target="_blank" 
      rel="noopener noreferrer" 
      className="text-gray-300 hover:text-orange-400 transition-colors duration-200"
    >
      Village Pacharahi, Post Baijalpur Bodla kawardha, India - Pin 491995
    </a>
  </div>
</div>
          </div>

          {/* Quick Links */}
          <div>
            <h2 className="mb-6 text-sm font-black uppercase tracking-widest text-white border-b-2 border-orange-500 w-fit pb-1">Organisation</h2>
            <ul className="text-gray-400 font-medium space-y-4">
              <li><Link to="/About" className="hover:text-orange-400 transition-colors">About Us</Link></li>
              <li><Link to="/Jobs" className="hover:text-orange-400 transition-colors">Careers</Link></li>
              <li><Link to="/Blog" className="hover:text-orange-400 transition-colors">Latest Blog</Link></li>
              <li><Link to="/Servicesmain" className="hover:text-orange-400 transition-colors">Impact & Programs</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h2 className="mb-6 text-sm font-black uppercase tracking-widest text-white border-b-2 border-orange-500 w-fit pb-1">Help Center</h2>
            <ul className="text-gray-400 font-medium space-y-4">
              <li><Link to="/Contact" className="hover:text-orange-400 transition-colors">Contact Support</Link></li>
              <li><Link to="/faq" className="hover:text-orange-400 transition-colors">Frequently Asked Questions</Link></li>
              <li><Link to="/whyus" className="hover:text-orange-400 transition-colors">Why Choose Us?</Link></li>
              <li><Link to="/Donation" className="hover:text-orange-400 transition-colors font-bold text-orange-500">Donate Now</Link></li>
            </ul>
          </div>

          {/* Newsletter / Legal */}
          <div>
            <h2 className="mb-6 text-sm font-black uppercase tracking-widest text-white border-b-2 border-orange-500 w-fit pb-1">Legal & Newsletter</h2>
            <p className="text-xs text-gray-500 mb-4 italic">Stay updated with our mission.</p>
            <div className="flex flex-col gap-2 mb-6">
               <Link to="/Privacy" className="text-gray-400 hover:text-white text-sm">Privacy Policy</Link>
               <Link to="/Terms" className="text-gray-400 hover:text-white text-sm">Terms & Conditions</Link>
            </div>
            {/* Simple Newsletter Input */}
            <div className="relative">
              <input 
                type="email" 
                placeholder="Your Email" 
                className="w-full bg-[#1a1a1a] border border-gray-800 rounded-full py-2 px-4 text-sm focus:border-orange-500 outline-none transition-all"
              />
              <button className="absolute right-1 top-1 bg-orange-600 hover:bg-orange-700 text-white px-4 py-1 rounded-full text-xs font-bold transition-all">
                JOIN
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Social Bar */}
        <hr className="my-10 border-gray-800" />
        
        <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <span className="text-sm text-gray-500 text-center sm:text-left">
            © {new Date().getFullYear()} <span className="text-white font-bold">Mahakal Social Welfare Society</span> | All rights reserved.
          </span>
          <div className="flex justify-center space-x-5">
            {[
              { icon: BsFacebook, link: "https://www.facebook.com/" },
              { icon: BsInstagram, link: "https://www.instagram.com/@lakhansinghdikshit384" },
               { icon: BsYoutube, link: "https://www.youtube.com/" },
              { icon: BsLinkedin, link: "https://in.linkedin.com/company/" }, 
            ].map((social, index) => (
              <a 
                key={index} 
                href={social.link} 
                target="_blank" 
                rel="noreferrer" 
                className="text-gray-400 hover:text-orange-500 transform hover:scale-125 transition-all duration-300"
              >
                <social.icon size={20} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footersection;